import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "gramo_cart_v1";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch { return []; }
  });
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (product, qty = 1) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.product_id === product.product_id);
      if (existing) {
        return prev.map((i) => i.product_id === product.product_id
          ? { ...i, quantity: i.quantity + qty } : i);
      }
      return [
        ...prev,
        {
          product_id: product.product_id,
          name: product.name,
          price: product.price,
          image_url: product.image_url,
          unit: product.unit,
          quantity: qty,
        },
      ];
    });
    setDrawerOpen(true);
  };

  const updateQty = (product_id, quantity) => {
    if (quantity <= 0) {
      removeItem(product_id);
      return;
    }
    setItems((prev) => prev.map((i) => i.product_id === product_id ? { ...i, quantity } : i));
  };

  const removeItem = (product_id) => {
    setItems((prev) => prev.filter((i) => i.product_id !== product_id));
  };

  const clear = () => setItems([]);

  const totals = useMemo(() => {
    const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
    const delivery = subtotal >= 499 || subtotal === 0 ? 0 : 40;
    const tax = +(subtotal * 0.05).toFixed(2);
    const total = +(subtotal + delivery + tax).toFixed(2);
    const count = items.reduce((s, i) => s + i.quantity, 0);
    return { subtotal: +subtotal.toFixed(2), delivery, tax, total, count };
  }, [items]);

  return (
    <CartContext.Provider value={{
      items, addItem, updateQty, removeItem, clear, totals,
      drawerOpen, setDrawerOpen,
    }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
